import React from 'react';
import { useListingType } from 'hooks';

export default Component => props => {
    const [state, actions] = useListingType();
    return (
        <Component
            {...props}
            listingType={state.listingType}
            updateListingData={actions.updateListingData}
        />
    );
};
